import RedditIcon from "@/components/ui/OpticksIcons/RedditIcon";
import { routesMap } from "@/components/routes/routes";
import ChannelIntegrationGuide from "@/components/channel-integration-guide/ChannelIntegrationGuide";
import type { ChannelIntegrationConfig } from "@/components/channel-integration-guide/ChannelIntegrationGuide.types";
import RedditIntegrationStep1 from "./steps/components/RedditIntegrationStep1";
import RedditIntegrationStep2 from "./steps/components/RedditIntegrationStep2";
import RedditIntegrationStep3 from "./steps/components/RedditIntegrationStep3";
import RedditIntegrationStep4 from "./steps/components/RedditIntegrationStep4";

const redditConfig: ChannelIntegrationConfig = {
  channelName: "Reddit Ads",
  channelDisplayName: "Reddit",
  platformKey: "reddit",
  oauthPlatformKey: "reddit",
  icon: <RedditIcon size={32} />,
  supportsOAuth: false,
  overviewPath: routesMap.integration.reddit.overview.path,
  linkingPath: routesMap.integration.reddit.linking.path,
  pixelManagementPath:
    routesMap.integration.channelsCenter.path + "?channel=reddit",
  guideSteps: [
    {
      content: (stepLabel) => <RedditIntegrationStep1 stepLabel={stepLabel} />,
    },
    {
      content: (stepLabel) => <RedditIntegrationStep2 stepLabel={stepLabel} />,
    },
    {
      content: (stepLabel) => <RedditIntegrationStep3 stepLabel={stepLabel} />,
    },
    {
      content: (stepLabel) => <RedditIntegrationStep4 stepLabel={stepLabel} />,
    },
  ],
};

const RedditIntegration = () => {
  return <ChannelIntegrationGuide config={redditConfig} />;
};

export default RedditIntegration;
